/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, Feb 2023
 * @flow
 */


import React from 'react';
import classes from './EmployeeLookup.module.css';
import strings from '../../../../globalization';
import Button from '../../../../components/Button';

const EmployeeLookup = ({ onEmployeeSelection, employees, onClosePopup }) => {
  return (
    <div className={classes.container}>
      <div className={classes.headerWrapper}>
        <div className={classes.headerTxt}>{strings.selectEmployee}</div>
        <div className={classes.closeBtn} onClick={onClosePopup}>X</div>
      </div>
      <div>
        <div className={classes.tablesWrapper}>
          {employees.map(employee => {
            return (
              <EmployeeCard
                key={`id-${employee.id}`}
                isEmployee
                employee={employee}
                onClick={() => onEmployeeSelection(employee)}
              />
            )
          })}
        </div>
        <div className={classes.buttonsWrapper}>
          <Button className={classes.btn} onClick={() => onEmployeeSelection()}>
            <span className={classes.skipText}>{strings.skip.toUpperCase()}</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

const EmployeeCard = ({ employee, onClick }) => {
  const { posId, firstName, lastName } = employee || {};
  return (
    <div className={classes.employeeCard} onClick={onClick} style={{ width: '30%' }}>
      <span className={classes.name}>{posId}</span>
      <span className={classes.name}>{lastName},</span>
      <span className={classes.name}>{firstName}</span>
    </div>
  );
};


export default EmployeeLookup;
